import { useEffect } from "react";
import Hero from "@/components/pt/Hero";
import AboutSection from "@/components/pt/AboutSection";
import DonationSection from "@/components/pt/DonationSection";
import Footer from "@/components/pt/Footer";

const IndexPT = () => {
  useEffect(() => {
    const title = "NeuroResearch Foundation - Pesquisa em Doenças Neurológicas";
    const description = "Fundação dedicada à pesquisa de doenças neurológicas: Dor Crônica, Alzheimer, Parkinson e ELA. Doe para apoiar a pesquisa de tratamentos inovadores. Apoiamos associações de pacientes em toda a Europa, incluindo doenças raras na Espanha e Portugal. Temos o prazer de apoiar a pesquisa sobre o sistema ECS e conectores neurais.";
    
    document.title = title;
    
    const updateMeta = (selector: string, attr: string, value: string) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        if (selector.includes('property=')) {
          el.setAttribute('property', selector.match(/property="([^"]+)"/)?.[1] || '');
        } else if (selector.includes('name=')) {
          el.setAttribute('name', selector.match(/name="([^"]+)"/)?.[1] || '');
        }
        document.head.appendChild(el);
      }
      el.setAttribute(attr, value);
    };

    updateMeta('meta[name="description"]', 'content', description);
    updateMeta('meta[property="og:title"]', 'content', title);
    updateMeta('meta[property="og:description"]', 'content', description);
    updateMeta('meta[property="og:locale"]', 'content', 'pt_PT');
    updateMeta('meta[property="og:type"]', 'content', 'website');
  }, []);

  return (
    <div className="min-h-screen">
      <Hero />
      <AboutSection />
      <DonationSection />
      <Footer />
    </div>
  );
};

export default IndexPT;
